const Logo = ({ className }) => (
	<svg
		width="35"
		height="35"
		viewBox="0 0 35 35"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g clipPath="url(#clip0_44_745)">
			<path
				className={className}
				d="M13.2283 17.5001C13.2283 18.544 12.8129 19.5436 12.0752 20.2811L6.71443 25.6408C6.6244 25.7308 6.53279 25.8161 6.43486 25.8951C6.20109 26.0893 5.94679 26.252 5.68144 26.383C5.13178 26.6562 4.53157 26.7921 3.93294 26.7921C2.9268 26.7921 1.91908 26.4083 1.15145 25.6392C-0.383817 24.1043 -0.383817 21.6139 1.15145 20.0773L3.72918 17.5001L1.15145 14.9213C-0.383817 13.3863 -0.383817 10.896 1.15145 9.3594C2.37556 8.13553 4.21093 7.88602 5.68144 8.61719C5.94995 8.74984 6.20583 8.91407 6.44276 9.10989C6.53595 9.18885 6.62756 9.27097 6.71443 9.35783L6.93082 9.57417L12.0752 14.7176C12.8144 15.4566 13.2283 16.4579 13.2283 17.5001Z"
				fill="#27272A"
			/>
			<path
				className={className}
				d="M13.2282 17.5001C13.2282 18.544 12.8128 19.5436 12.0752 20.2811L6.71437 25.6408C6.62434 25.7308 6.53273 25.8161 6.4348 25.8951C6.20103 26.0893 5.94673 26.252 5.68138 26.383C5.30704 26.1983 4.95797 25.9503 4.64681 25.6392C3.11154 24.1043 3.11154 21.6139 4.64681 20.0773L7.22454 17.5001L4.64839 14.9213C3.11312 13.3863 3.11312 10.896 4.64839 9.35941C4.95955 9.04831 5.30862 8.80195 5.68138 8.61719C5.94989 8.74984 6.20577 8.91407 6.4427 9.10989C6.53589 9.18885 6.6275 9.27097 6.71437 9.35783L6.93076 9.57418L12.0752 14.7176C12.8144 15.4566 13.2282 16.4579 13.2282 17.5001Z"
				fill="#27272A"
			/>
			<path
				className={className}
				d="M34.9998 17.4999C34.9998 26.6134 27.5841 34.0277 18.4689 34.0277H10.5793C8.507 34.0277 6.80746 32.4248 6.65741 30.3893C6.64793 30.2929 6.64478 30.195 6.64478 30.094C6.64478 27.9226 8.40591 26.1602 10.5793 26.1602H18.4704C23.2468 26.1602 27.134 22.2754 27.134 17.4984C27.134 12.7229 23.2468 8.83652 18.4704 8.83652H10.5793C8.40749 8.83652 6.64478 7.07573 6.64478 4.90276C6.64478 4.80328 6.64793 4.70379 6.65741 4.60746C6.80746 2.57504 8.50542 0.972168 10.5793 0.972168H18.4704C27.5857 0.972168 34.9998 8.38645 34.9998 17.4999Z"
				fill="#27272A"
			/>
			<path
				className={className}
				d="M6.93069 9.57756C6.75221 9.44175 6.58794 9.28383 6.44263 9.11328C6.53582 9.19224 6.62743 9.27436 6.7143 9.36121L6.93069 9.57756Z"
				fill="#27272A"
			/>
			<path
				className={className}
				d="M6.71438 25.6408C6.62435 25.7308 6.53274 25.816 6.43481 25.895C6.58487 25.7166 6.75545 25.5555 6.93867 25.4165L6.71438 25.6408Z"
				fill="#27272A"
			/>
			<path
				className={className}
				d="M29.3469 17.5002C29.3469 25.1166 23.1506 31.3101 15.5343 31.3101H8.93831C8.05064 31.3101 7.24826 30.9596 6.65595 30.3895C6.64647 30.2931 6.64331 30.1952 6.64331 30.0942C6.64331 27.9228 8.40445 26.1604 10.5778 26.1604H18.469C23.2454 26.1604 27.1325 22.2756 27.1325 17.4986C27.1325 12.7231 23.2454 8.83674 18.469 8.83674H10.5794C8.4076 8.83674 6.64489 7.07595 6.64489 4.90299C6.64489 4.8035 6.64805 4.70401 6.65753 4.60768C7.24984 4.03759 8.05222 3.68701 8.93989 3.68701H15.5343C23.1506 3.69017 29.3469 9.88374 29.3469 17.5002Z"
				fill="#27272A"
			/>
		</g>
		<defs>
			<clipPath id="clip0_44_745">
				<rect
					width="35"
					height="33.0555"
					fill="white"
					transform="translate(0 0.972168)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default Logo;
